import { ActionLogMapper } from "@/data/mapper/super-admin/action-log-mapper";
import { OperationInfoMapper } from "@/data/mapper/super-admin/operation-info-mapper";
import { ActionLogRequestPayload } from "@/data/payload/super-admin/action-log-request-payload";
import { OperationLogRequestPayload } from "@/data/payload/super-admin/operation-log-request-payload";
import { safeMapToEntity } from "@/data/repo-Implement/safe-map-to-entity";
import { SuperAdminSource } from "@/data/source/super-admin-source";
import { ActionLogInfoEntity } from "@/domain/entity/super-admin/action-log-info-entity";
import { OperationLogInfoEntity } from "@/domain/entity/super-admin/operation-log-info-entity";
import { SuperAdminRepository } from "@/domain/repository/super-admin-repository";
import { SATError, SATResult } from "@sadtx/sat-error";

/**
 * 슈퍼 관리자 레포지토리 구현체
 */

export class SuperAdminRepositoryImpl implements SuperAdminRepository {
  constructor(private readonly superAdminSource: SuperAdminSource) {}

  async getOperationLog(
    payload: OperationLogRequestPayload
  ): Promise<SATResult<OperationLogInfoEntity, SATError>> {
    const result = await this.superAdminSource.getOperationLog(payload);

    if (result.isFailure) {
      return SATResult.failure(result.error);
    }

    return safeMapToEntity(
      result.value,
      OperationInfoMapper.toEntity,
      "SuperAdminRepositoryImpl::getOperationLog"
    );
  }

  async getActionLog(
    payload: ActionLogRequestPayload
  ): Promise<SATResult<ActionLogInfoEntity, SATError>> {
    const result = await this.superAdminSource.getActionLog(payload);

    if (result.isFailure) {
      return SATResult.failure(result.error);
    }

    return safeMapToEntity(
      result.value,
      ActionLogMapper.toEntity,
      "SuperAdminRepositoryImpl::getActionLog"
    );
  }
}
